require('cleave.js');
require('../vendor/countries');
require('jquery-input-mask-phone-number');

window.FormHelpers = (function(w, $) {
  function toggleAccordionItem(that) {
    var accordion = that.closest('.accordion');

    accordion.toggleClass('is-open');
    accordion.find('.accordion__body').slideToggle(function() {
      $(this).find('textarea').focus();
    }).animate(
      { opacity: 1 },
      { queue: false, duration: 'slow' }
    );
  }

  function inputFormatting() {
    if($('.credit-card').length) {
      new Cleave('.credit-card', {
        creditCard: true
      });
    }

    if($('.expiration').length) {
      new Cleave('.expiration', {
        date: true,
        datePattern: ['m', 'y']
      });
    }

    if($('.cvc').length) {
      new Cleave('.cvc', {
        numericOnly: true,
        blocks: [4],
      });
    }

    if($('.month').length) {
      new Cleave('.month', {
        date: true,
        datePattern: ['m']
      });
    }

    if($('.day').length) {
      new Cleave('.day', {
        date: true,
        datePattern: ['d']
      });
    }

    if($('.year').length) {
      new Cleave('.year', {
        date: true,
        datePattern: ['Y']
      });
    }

    if($('.phone').length) {
        $('.phone').usPhoneFormat();
    }

    if($('.username').length) {
      new Cleave('.username', {
        lowercase: true,
        blocks: [50]
      });

      $('.username').on('input', function() {
        var value = $(this).val();

        $(this).val(value.replace(/\s+/g, ''));
      });
    }
  }

  function formInteractions(isInit) {

    if($('#member_how_hear').is(':checked')) {
        showHidden($('#js_referred'), isInit);
    } else {
        reHideHidden($('#js_referred'));
    }

    if($('#other_how_hear').is(':checked')) {
        showHidden($('#js_other_how_hear'), isInit);
    } else {
        reHideHidden($('#js_other_how_hear'));
    }
  }

  function showHidden(element, isInit) {
    if(!isInit) {
      // If on form change
      element
        .slideDown(function() {
          // $('html, body').animate({ scrollTop: $(this).find('input').offset().top - 20 }, 500);
          $(this).removeClass('hidden').find('input');
        }).animate(
          { opacity: 1 },
          { queue: false, duration: 'slow' }
        );

      // Revalidate
      setTimeout(function() {
        ValidationModule.validateForm(element);
      }, 415);
    } else {
      // If on init (so opening animation doesn't happen on form error)
      element.removeClass('hidden').css('opacity', 1);
    }
  }

  function reHideHidden(element) {
    element
      .slideUp(function() {
        $(this).addClass('hidden').find('input');
      }).animate(
        { opacity: 0 },
        { queue: false, duration: 'fast' }
      );
  }

  function fileUpload(input, e) {
    var label = input.next('label');
    var labelVal = label.html();

    var fileName = '';

    if(e.target.value) {
      fileName = e.target.value.split('\\').pop();
    }

    if(fileName) {
      label.find('span').html(fileName);
    } else {
      label.html(labelVal);
    }

    label.find('strong').html('Update File');

    // Firefox bug fix
    input
      .on('focus', function() { input.addClass('has-focus'); })
      .on('blur', function() { input.removeClass('has-focus'); });
  }

  function updatePicture(input) {
    if (input[0].files && input[0].files[0]) {
      var reader = new FileReader();

      reader.onload = function (e) {
        input.parent().find('label img').attr('src', e.target.result);
      };

      reader.readAsDataURL(input[0].files[0]);
    }
  }

  function handleAddress() {
    // Auto fill Country and Region values on load and change
    loadCountries();

    $('#country').on('change', function() {
      // Clear region value
      $('#region').val('');

      // Remove required from Zip/Postal code if not Canada or USA
      var value = $(this).val();
      var $zipPostal = $('#zip_postal');

      if(value !== 'Canada' && value !== 'USA') {
        $zipPostal.removeClass('required');
      } else {
        $zipPostal.removeClass('required').addClass('required');
      }

      // Revalidate
      ValidationModule.validateForm($(this));
    });
  }

  return {
    toggleAccordionItem,
    inputFormatting,
    formInteractions,
    fileUpload,
    updatePicture,
    handleAddress
  };
})(window, jQuery)
